module.exports = __webpack_public_path__ + "static/media/icon_request_a.5458653e.svg";